package serialized

import it.neckar.lizergy.model.configuration.quote.builder.InverterConfiguration
import it.neckar.lizergy.model.configuration.quote.builder.InverterConfiguration.MpptInputConfiguration
import it.neckar.lizergy.model.configuration.quote.builder.InverterType.InverterId
import it.neckar.lizergy.model.configuration.quote.builder.ResolvedInverterConfiguration
import it.neckar.lizergy.model.price.ProductResolver
import kotlinx.serialization.Serializable

@Serializable
data class SerializedInverterConfiguration(
  override val inverterId: InverterId,
  override val inverterIndex: Int,
  override val mpptInputConfigurations: List<MpptInputConfiguration>,
) : InverterConfiguration {

  init {
    //Ensure the mpptInputConfigurations have different ids
    val distinctMpptInputConfigurationIds = mpptInputConfigurations.map { it.id }.distinct()


    if (distinctMpptInputConfigurationIds.size != mpptInputConfigurations.size) {
      DuplicateIdsCollector.addAll(mpptInputConfigurations.map { it.id })
    }
    if (false) {
      require(distinctMpptInputConfigurationIds.size == mpptInputConfigurations.size) {
        "mpptInputConfigurations must have different ids. But was ${mpptInputConfigurations.map { it.id }}"
      }
    }
  }

  fun resolve(productResolver: ProductResolver): ResolvedInverterConfiguration {
    return ResolvedInverterConfiguration(
      inverter = productResolver.getConfigurableInverter(inverterId),
      inverterIndex = inverterIndex,
      mpptInputConfigurations = mpptInputConfigurations,
    )
  }

  object DuplicateIdsCollector {
    val collectedIds: MutableSet<MpptInputConfiguration.MpptInputConfigurationId> = mutableSetOf<MpptInputConfiguration.MpptInputConfigurationId>()

    fun addAll(entries: List<MpptInputConfiguration.MpptInputConfigurationId>) {
      collectedIds.addAll(entries)
    }

  }
}

fun ResolvedInverterConfiguration.unResolve(): SerializedInverterConfiguration {
  return SerializedInverterConfiguration(
    inverterId = inverter.id,
    inverterIndex = inverterIndex,
    mpptInputConfigurations = mpptInputConfigurations,
  )
}

